<template>
    <zen-message-modal :isOpen="isOpen" title="Create API Token">
        <form @submit.prevent="$emit('submit')" class="space-y-4">
            <div>
                <label
                    for="token-name"
                    class="block text-sm font-medium text-taupe-800 mb-1"
                    >Token name</label
                >
                <input
                    type="text"
                    id="token-name"
                    v-model="name"
                    required
                    maxlength="255"
                    placeholder="e.g. CI deployment"
                    class="block w-full rounded-md border-taupe-300 bg-white px-3 py-2 text-taupe-900 shadow-xs focus:border-sky-500 focus:ring-sky-500 sm:text-sm"
                />
            </div>

            <div>
                <p class="block text-sm font-medium text-taupe-800 mb-2">
                    Scopes
                </p>
                <div class="space-y-2">
                    <label
                        v-for="scope in availableScopes"
                        :key="scope.value"
                        class="flex items-center gap-2 cursor-pointer"
                    >
                        <input
                            type="checkbox"
                            :value="scope.value"
                            v-model="scopes"
                            class="h-4 w-4 rounded border-taupe-300 text-sky-600 focus:ring-sky-500"
                        />
                        <span class="text-sm text-taupe-800">{{
                            scope.label
                        }}</span>
                        <span class="text-xs text-taupe-500">{{
                            scope.description
                        }}</span>
                    </label>
                </div>
            </div>

            <div>
                <label
                    for="token-expires"
                    class="block text-sm font-medium text-taupe-800 mb-1"
                    >Expiry date
                    <span class="font-normal text-taupe-500"
                        >(optional)</span
                    ></label
                >
                <input
                    type="date"
                    id="token-expires"
                    v-model="expiresAt"
                    class="block w-full rounded-md border-taupe-300 bg-white px-3 py-2 text-taupe-900 shadow-xs focus:border-sky-500 focus:ring-sky-500 sm:text-sm"
                />
            </div>

            <div>
                <p class="block text-sm font-medium text-taupe-800 mb-1">
                    Project/environment access
                    <span class="font-normal text-taupe-500">(optional)</span>
                </p>
                <p class="text-xs text-taupe-500 mb-2">
                    Restrict this token to specific projects or environments.
                    Leave empty for unrestricted access.
                </p>
                <resource-grants-editor
                    v-model="resourceGrants"
                    :projects="projects"
                />
            </div>

            <p v-if="error" class="text-sm text-red-600">
                {{ error }}
            </p>

            <div class="flex justify-end gap-3 pt-2">
                <zen-button variant="secondary" @click="$emit('close')">
                    Cancel
                </zen-button>
                <zen-button
                    type="submit"
                    variant="primary"
                    :disabled="scopes.length === 0"
                    :processing="processing"
                    processing-label="Creating…"
                >
                    Create token
                </zen-button>
            </div>
        </form>
    </zen-message-modal>
</template>

<script>
import ResourceGrantsEditor from '@/screens/_components/admin/ResourceGrantsEditor.vue'

export default {
    name: 'CreateApiTokenModal',
    components: { ResourceGrantsEditor },
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        form: {
            type: Object,
            required: true,
        },
        availableScopes: {
            type: Array,
            required: true,
        },
        projects: {
            type: Array,
            required: true,
        },
        processing: {
            type: Boolean,
            default: false,
        },
        error: {
            type: String,
            default: null,
        },
    },
    emits: ['close', 'submit', 'update:form'],
    computed: {
        name: {
            get() {
                return this.form.name
            },
            set(value) {
                this.$emit('update:form', { ...this.form, name: value })
            },
        },
        scopes: {
            get() {
                return this.form.scopes
            },
            set(value) {
                this.$emit('update:form', { ...this.form, scopes: value })
            },
        },
        expiresAt: {
            get() {
                return this.form.expires_at
            },
            set(value) {
                this.$emit('update:form', {
                    ...this.form,
                    expires_at: value,
                })
            },
        },
        resourceGrants: {
            get() {
                return this.form.resource_grants
            },
            set(value) {
                this.$emit('update:form', {
                    ...this.form,
                    resource_grants: value,
                })
            },
        },
    },
}
</script>
